define('model/BookingServerRequestModel',['require','lib/model/BaseModel','model/BookingModel','collection/BookingCollection','plugin/invoice/model/InvoiceModel'],function (require) {

	var BaseModel = require('lib/model/BaseModel');
    var BookingModel = require('model/BookingModel');
    var BookingCollection = require('collection/BookingCollection');
    //var CartModel = require('plugin/paid-events/model/CartModel');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');
	
	/**
	 * Booking request model data
	 * 
	 * @class BookingServerRequestModel
	 */
	return BaseModel.extend({
		
		url: '/booking/',
		
		defaults: {
			current_booking: null,
			require_confirm: false,
			bookings: new BookingCollection(),
			cart: {},
			batch_type: null,
			batch_hash: null,
			batch_id: null,
			confirm: true
		},

		parse: function (resp, options) {
			var result = BaseModel.prototype.parse.apply(this, [resp, options]);
			result.bookings = new BookingCollection(result.bookings);
            //result.cart = new CartModel(result.cart);
            result.invoice = new InvoiceModel(result.invoice);
            result.current_booking = new BookingModel(result.current_booking);

			return result;
		},

		toJSON: function () {
			var result = BaseModel.prototype.toJSON.apply(this, arguments);
			if (this.jsonIsForSave) {
				result.current_booking = result.current_booking.toJSON();
				if (result.current_booking.service) {
					delete result.current_booking.service;
				}
				if (result.current_booking.provider) {
					delete result.current_booking.provider;
				}
				if (result.current_booking.category) {
					delete result.current_booking.category;
				}
				if (result.current_booking.location) {
					delete result.current_booking.location;
				}
			}
			return result;
		},

		save: function () {
			this.jsonIsForSave = true;
			var result = BaseModel.prototype.save.apply(this, arguments);
			this.jsonIsForSave = false;
			return result;
		},

		validate: function () {
			return this.get('current_booking').validate();
		}
		
	}, {

		createWithCurrentBooking: function (bookingModel) {
			var strippedModel = bookingModel.clone();
			
			strippedModel.set({
				service: null,
				provider: null,
				prices: null
			}, {
				silent: true
			});

			return new this({
				current_booking: strippedModel
			});
		}

	});
	
});
